import { getUrl, Request } from "../../request";

export const postNotification = (
  device_token,
  operating_system,
  user_agent,
  city_id
) => {
  return Request.post(getUrl("/api/v1/notification/firebase/"), {
    device_token,
    operating_system,
    user_agent,
    city_id,
  });
};
